import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/bdeh8989/dev.ecole-st-augustin.fr/v2/app/components/breadcrumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/bdeh8989/dev.ecole-st-augustin.fr/v2/app/components/tiptap/page-content.tsx");
